import React, { Fragment } from 'react';
import sad from '../../assets/images/other-images/sad.png';
import { Link, useNavigate } from 'react-router-dom';
import { BACK_TO_HOME_PAGE } from "../../constant";
const Error404 = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        const jwt_token = localStorage.getItem('access');
        const user = localStorage.getItem('user');

        if (jwt_token && user) {
            if (user === 'customeradmin') {
                navigate(`${process.env.PUBLIC_URL}/customeradmin/dashboard`);
            } else if (user === "superadmin_approver" || user === "superadmin_executive") {
                navigate(`${process.env.PUBLIC_URL}/admin/vdi_customer`);
            } else if (user === "Verifier") {
                navigate(`${process.env.PUBLIC_URL}/verifier/vessels`);
            } else if (user === "Surveyor") {
                navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
            } else if (user === "SiteSurveyor") {
                navigate(`${process.env.PUBLIC_URL}/sitecoordinator/vessels`);
            } else {
                navigate(`${process.env.PUBLIC_URL}/signin`);
            }
        } else {
            navigate(`${process.env.PUBLIC_URL}/signin`);
        }
    };

    return (
        <Fragment>
            <div className="d-flex align-items-center justify-content-center vh-100" style={{ backgroundColor: '#f4f7f9' }}>
                <div className="text-center p-5" style={{
                    backgroundColor: 'white',
                    borderRadius: '20px',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                    maxWidth: '600px',
                    width: '90%'
                }}>
                    <h1 className="display-1 fw-bold mb-0" style={{
                        background: 'linear-gradient(45deg, #2264ab, #3b82f6)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        fontSize: '120px',
                        lineHeight: '1.2'
                    }}>
                        404
                    </h1>

                    <h3 className="h2 mb-4 text-dark font-weight-bold" style={{ letterSpacing: '-0.5px' }}>
                        Oops! Page Not Found
                    </h3>

                    <p className="text-muted mb-5" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                        The page you are attempting to reach is currently not available.
                        This may be because the page does not exist or has been moved.
                    </p>

                    <button
                        onClick={handleGoHome}
                        className="btn btn-lg fw-bold px-5 py-3 rounded-pill transition-all"
                        style={{
                            backgroundColor: '#2264ab',
                            color: 'white',
                            border: 'none',
                            boxShadow: '0 4px 15px rgba(34, 100, 171, 0.3)',
                            transform: 'translateY(0)',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer'
                        }}
                        onMouseOver={(e) => {
                            e.target.style.transform = 'translateY(-3px)';
                            e.target.style.boxShadow = '0 6px 20px rgba(34, 100, 171, 0.4)';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 4px 15px rgba(34, 100, 171, 0.3)';
                        }}
                    >
                        {BACK_TO_HOME_PAGE || "Go Back Home"}
                    </button>
                </div>
            </div>
        </Fragment>
    );
};

export default Error404;